var dfs = require('./dfs')

module.exports = preorder

function preorder (g, vs) {
  return dfs(g, vs, 'pre')
}



//////////////////
// WEBPACK FOOTER
// ./~/graphlibrary/lib/alg/preorder.js
// module id = 1628
// module chunks = 0